import { UAParser } from 'my-ua-parser';

const uaParser = new UAParser();
const browser = uaParser.getBrowser();
const engine = uaParser.getEngine();
const os = uaParser.getOS();
export const isMozilla = () => engine.name === 'Gecko';
export const isSafari = () => browser.name === 'Safari';
export const isEdge = () => browser.name === 'Edge';
export const getBrowserPlatform = () => os.name;
export const getBrowserVersionNumber = () => browser.version;
export const getBrowserName = () => browser.name;
